module.exports = "/_next/static/images/DevelopOnSegment@2x-e80775e5d5b9123cec4ccee7d38f1817.png";